export default __webpack_public_path__ + "static/icon-13-3-8e0a5dbcc44db483d6da1100b22b440c.png";